import React, { useState, useEffect } from "react";
import { Form, Button, Col, Card, Row, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CheckoutSteps from "../components/CheckoutSteps";
import { saveShippingAddress } from "../actions/cartActions";

function ClientInfoScreen({ history }) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const cartAdjustments = localStorage.getItem("adjustments")
    ? JSON.parse(localStorage.getItem("adjustments"))
    : [];
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientCity, setClientCity] = useState("");
  const [clientState, setClientState] = useState("");
  const [clientZip, setClientZip] = useState("");
  const [clientCountry, setClientCountry] = useState("");

  const dispatch = useDispatch();

  function validateAndFormatPhone(phoneNumber) {
    if (typeof phoneNumber !== "string") {
      console.error("Invalid input type");
      return; // Direct return without changing the state
    }

    // Remove all non-digits except the leading +
    var phoneNumberDigits = phoneNumber.replace(/[^\d+]/g, "");

    // Check if the number is potentially valid before formatting
    if (
      phoneNumberDigits.length === 10 ||
      (phoneNumberDigits.length === 11 && phoneNumberDigits.startsWith("1"))
    ) {
      var formattedPhoneNumber = phoneNumberDigits;
      if (phoneNumberDigits.length === 10) {
        formattedPhoneNumber = phoneNumberDigits.replace(
          /(\d{3})(\d{3})(\d{4})/,
          "($1) $2-$3"
        );
      } else if (phoneNumberDigits.startsWith("1")) {
        formattedPhoneNumber = phoneNumberDigits.replace(
          /(\d{1})(\d{3})(\d{3})(\d{4})/,
          "$1 ($2) $3-$4"
        );
      }
      setClientPhone(formattedPhoneNumber);
    } else {
      // Update the state with non-formatted input to allow free typing
      setClientPhone(phoneNumber);
    }
  }
  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else if (cartItems.length === 0 || cartItems.length > 1) {
      history.push("/cart");
    } else if (!cartAdjustments.selection) {
      history.push("/adjustments");
    } else if (cart.salesProgram.length === 0) {
      history.push("/adjustments");
    }
  }, [history, userInfo, cartItems, cartAdjustments, cart.salesProgram]);

  const submitHandler = (e) => {
    e.preventDefault();
    history.push("/placequote");

    dispatch(
      saveShippingAddress({
        clientName,
        clientEmail,
        clientPhone,
        clientAddress,
        clientCity,
        clientState,
        clientZip,
        clientCountry,
      })
    );
  };

  return (
    <Container>
      <CheckoutSteps step1 step2 step3 />

      <Row className="justify-content-md-center">
        <Col xs={12} md={6}>
          <h1>Customer Information</h1>

          <Card className="my-3 p-3 rounded">
            <Form onSubmit={submitHandler}>
              <Form.Group controlId="clientName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="text"
                  placeholder="Enter client name"
                  required
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="email"
                  placeholder="Enter client email"
                  required
                  value={clientEmail}
                  onChange={(e) => setClientEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientPhone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="tel" // Changed from 'number' to 'tel' to allow non-numeric characters
                  placeholder="Enter client phone"
                  required
                  value={clientPhone}
                  onChange={(e) => setClientPhone(e.target.value)} // Directly update state with input value
                  onBlur={(e) => validateAndFormatPhone(e.target.value)} // Apply formatting onBlur
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="text"
                  placeholder="Enter client address"
                  required
                  value={clientAddress}
                  onChange={(e) => setClientAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientCity">
                <Form.Label>City</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="text"
                  placeholder="Enter client city"
                  required
                  value={clientCity}
                  onChange={(e) => setClientCity(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientState">
                <Form.Label>State</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="text"
                  placeholder="Enter client state"
                  required
                  value={clientState}
                  onChange={(e) => setClientState(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientZip">
                <Form.Label>Zip Code</Form.Label>
                <Form.Control
                  className="rounded mb-4"
                  type="text"
                  placeholder="Enter client zip"
                  required
                  value={clientZip}
                  onChange={(e) => setClientZip(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group controlId="clientCountry">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  className="rounded mb-4 form-select"
                  as="select"
                  required
                  value={clientCountry}
                  onChange={(e) => setClientCountry(e.target.value)}
                >
                  <option value="">Select a country</option>
                  <option value="US">United States</option>
                  <option value="CA">Canada</option>
                </Form.Control>
              </Form.Group>

              <div className="py-5 text-center">
                <Button
                  className="button adjust"
                  type="submit"
                  variant="primary"
                >
                  Continue
                </Button>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ClientInfoScreen;
